// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helpcenter-container {
  padding: 20px 50px;
  max-height: calc(100vh - 140px);
  overflow: auto;
  text-align: justify;
}
.helpcenter-container td,
.helpcenter-container th {
  padding-left: 60px;
}
.helpcenter-container .body5 {
  padding-left: 60px;
}
.helpcenter-container .body7 {
  padding-top: 15px;
}
.helpcenter-container .body6 {
  margin-top: -40px;
  margin-left: 110px;
  color: #c00;
}
.helpcenter-container .body {
  width: 100%;
  display: table;
}
.helpcenter-container .body3 {
  display: table-row;
  height: 100px;
}
.helpcenter-container .body1 {
  width: 20%;
  display: table-cell;
}
.helpcenter-container .body2 {
  display: table-cell;
  padding-left: 40px;
}
.helpcenter-container .body4 {
  padding-left: 70px;
}

.header-style {
  margin: 10px;
  font-size: 18px;
}

/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/
mat-card.card-style {
  padding: 50px;
}

.tgpp-print-title {
  display: none;
}

.tgpp-title {
  display: none;
}

.tgpp-print-icon {
  margin: 10px;
  cursor: pointer;
  float: right;
}

@media print {
  .helpcenter-container {
    max-height: none;
    overflow: auto;
  }
  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/
  mat-card.card-style {
    box-shadow: none;
  }
  .tgpp-print-title {
    margin: 5px;
    display: block;
    float: left;
  }
  .tgpp-title {
    margin: 5px;
    color: rgb(189, 185, 185);
    display: block;
  }
  .title {
    display: flex;
    place-content: center;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/feature/helpcenter/helpcenter.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,+BAAA;EACA,cAAA;EACA,mBAAA;AACF;AACE;;EAEI,kBAAA;AACN;AACE;EACI,kBAAA;AACN;AACE;EACI,iBAAA;AACN;AACE;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;AACN;AACE;EACI,WAAA;EACA,cAAA;AACN;AACE;EACI,kBAAA;EACA,aAAA;AACN;AACE;EACI,UAAA;EACA,mBAAA;AACN;AACE;EACI,mBAAA;EACA,kBAAA;AACN;AACE;EACI,kBAAA;AACN;;AAGA;EACE,YAAA;EACA,eAAA;AAAF;;AAIA,0HAAA;AACA;EACE,aAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,YAAA;EACA,eAAA;EACA,YAAA;AAFF;;AAKA;EACE;IACE,gBAAA;IACA,cAAA;EAFF;EAIA,0HAAA;EACA;IACE,gBAAA;EAFF;EAKA;IACE,WAAA;IACA,cAAA;IACA,WAAA;EAHF;EAQA;IACE,WAAA;IACA,yBAAA;IACA,cAAA;EANF;EASA;IACE,aAAA;IACA,qBAAA;IACA,mBAAA;EAPF;AACF","sourcesContent":[".helpcenter-container {\n  padding: 20px 50px;\n  max-height: calc(100vh - 140px);\n  overflow: auto;\n  text-align: justify;\n\n  td,\n  th {\n      padding-left: 60px;\n  }\n  .body5 {\n      padding-left: 60px;\n  }\n  .body7 {\n      padding-top: 15px;\n  }\n  .body6 {\n      margin-top: -40px;\n      margin-left: 110px;\n      color: #c00;\n  }\n  .body {\n      width: 100%;\n      display: table;\n  }\n  .body3 {\n      display: table-row;\n      height: 100px\n  }\n  .body1 {\n      width: 20%;\n      display: table-cell;\n  }\n  .body2 {\n      display: table-cell;\n      padding-left: 40px\n  }\n  .body4 {\n      padding-left: 70px\n  }\n}\n\n.header-style {\n  margin: 10px;\n  font-size: 18px;\n\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/\nmat-card.card-style {\n  padding: 50px;\n}\n\n.tgpp-print-title {\n  display: none;\n\n}\n\n.tgpp-title {\n  display: none;\n}\n\n.tgpp-print-icon {\n  margin: 10px;\n  cursor: pointer;\n  float: right;\n}\n\n@media print {\n  .helpcenter-container {\n    max-height: none;\n    overflow: auto;\n  }\n  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/\n  mat-card.card-style {\n    box-shadow: none;\n  }\n\n  .tgpp-print-title {\n    margin: 5px;\n    display: block;\n    float: left;\n\n\n  }\n\n  .tgpp-title {\n    margin: 5px;\n    color: rgb(189, 185, 185);\n    display: block;\n  }\n\n  .title {\n    display: flex;\n    place-content: center;\n    align-items: center;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
